import { StoreBlock } from '@site-builder/common/src/types/blocks';

import type { ScriptsState } from '../../../reducers/modules/site-builder/scripts';

import { canShowCart, PlaceTypes } from '../../../utils/cart-helper';
import events from '../../events';
import { getStore } from '../../store';
import { translations } from '../../translations';
import { initCartModalOnce } from './cartModal';
import { createSocket, loadStore } from './load-store';

const initStoreBlock = async ({
  block,
  blockStructure,
  data,
}: {
  block: HTMLDivElement;
  blockStructure: StoreBlock;
  data: ScriptsState;
}) => {
  const store = getStore();
  const { landingServices } = store.getState();
  const { auth, cart: cartSettings, isMultipage, isNewScheme } = data;
  const enableCart = canShowCart({
    isMultipage,
    isNewScheme,
    enableCart: cartSettings.enable,
    placeType: PlaceTypes.STORE,
  });
  const loadStoreProps = {
    data,
    block,
    auth,
    blockStructure,
    enableCart,
    ...landingServices,
  };

  initCartModalOnce({ data, translations });

  await loadStore(loadStoreProps);
  await createSocket(loadStoreProps);
};

export default async ({
  block,
  blockStructure,
  data,
}: {
  block: HTMLDivElement;
  blockStructure: StoreBlock;
  data: ScriptsState;
}) => {
  await initStoreBlock({
    block,
    blockStructure,
    data,
  });

  window.addEventListener(events.store.rerender, () => {
    initStoreBlock({
      block,
      blockStructure,
      data,
    });
  });
};
